<template>
  <el-dialog :title="dialogTitle" :visible.sync="visible" width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" @close="handleClose" top="5vh">
    <div class="dialog-content">
      <el-form ref="customerForm" :model="form" :rules="rules" label-width="120px" size="small">
        <el-row :gutter="20">
          <el-col :span="8" v-if="isEdit">
            <el-form-item label="编号">
              <el-input v-model="form.customerCode" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="form.customerName" placeholder="请输入客户名称" :disabled="isEdit" clearable>
                <el-button slot="append" icon="el-icon-search" @click="openCustomerReference" :disabled="isEdit">参照</el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="form.contactPerson" placeholder="请输入联系人" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="form.contactPhone" placeholder="请输入联系电话" clearable maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开票主体" prop="invoiceEntity">
              <el-select v-model="form.invoiceEntity" placeholder="请选择开票主体" clearable style="width: 100%;">
                <el-option label="晨宇安全科技集团有限公司" value="晨宇安全科技集团有限公司"></el-option>
                <el-option label="晨宇安全科技集团有限公司泉州分公司" value="晨宇安全科技集团有限公司泉州分公司"></el-option>
                <el-option label="晨宇安全科技集团有限公司漳州分公司" value="晨宇安全科技集团有限公司漳州分公司"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="跟单员" prop="followUpPerson">
              <el-select v-model="form.followUpPerson" placeholder="请选择跟单员" multiple collapse-tags clearable style="width: 100%;" :loading="employeeLoading" @focus="loadEmployeeList">
                <el-option v-for="employee in employeeList" :key="employee.employeePid" :label="employee.employeeName" :value="employee.employeeName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目来源" prop="projectSource">
              <el-select v-model="form.projectSource" placeholder="请选择项目来源" clearable style="width: 100%;">
                <el-option label="投标" value="投标"></el-option>
                <el-option label="中间人介绍" value="中间人介绍"></el-option>
                <el-option label="公司派发" value="公司派发"></el-option>
                <el-option label="商务自拓" value="商务自拓"></el-option>
                <el-option label="员工介绍" value="员工介绍"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户状态" prop="status">
              <el-select v-model="form.status" placeholder="请选择客户状态" clearable style="width: 100%;">
                <el-option label="进行中" value="ongoing"></el-option>
                <el-option label="完结" value="completed"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="返点方案" prop="rebatePlan">
              <el-select v-model="form.rebatePlan" placeholder="请选择返点方案" clearable style="width: 100%;" @change="onRebatePlanChange">
                <el-option label="固定百分比" :value="'1'"></el-option>
                <el-option label="按检测日期以及层数不同百分比" :value="'2'"></el-option>
                <el-option label="固定单台费用" :value="'3'"></el-option>
                <el-option label="按层数不同百分比及固定单台" :value="'4'"></el-option>
                <el-option label="其他" :value="'5'"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="常用邮寄信息" prop="mailingInfo">
              <el-input v-model="form.mailingInfo" type="textarea" :rows="2" placeholder="请输入常用邮寄信息（收件人、地址、电话等）" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="form.rebatePlan === '1'">
          <el-col :span="8">
            <el-form-item label="开始日期" prop="fixedRebateStart">
              <el-date-picker v-model="form.fixedRebateStart" type="date" placeholder="选择开始日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束日期" prop="fixedRebateEnd">
              <el-date-picker v-model="form.fixedRebateEnd" type="date" placeholder="选择结束日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="返点百分比" prop="ratioValue">
              <el-input v-model="form.ratioValue" placeholder="请输入百分比(如50)" clearable>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.fixedRebateRemark" placeholder="请输入备注" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="form.rebatePlan === '2'">
          <el-col :span="24">
            <el-form-item label="返点百分比设置">
              <div style="margin-bottom: 10px;">
                <el-button type="primary" size="mini" @click="addRebateRow">新增</el-button>
              </div>
              <el-table :data="form.rebateTiers" border size="small" style="width: 100%;">
                <el-table-column label="开始日期" width="200">
                  <template slot="header">
                    <span style="color: #F56C6C;">*</span> 开始日期
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'rebateTiers.' + scope.$index + '.startDate'" :rules="[{ required: true, message: '请选择开始日期', trigger: 'change' }]" style="margin-bottom: 0;">
                      <el-date-picker v-model="scope.row.startDate" type="date" placeholder="选择开始日期" style="width: 100%;" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="结束日期" width="200">
                  <template slot="header">
                    <span style="color: #F56C6C;">*</span> 结束日期
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'rebateTiers.' + scope.$index + '.endDate'" :rules="[{ required: true, message: '请选择结束日期', trigger: 'change' }]" style="margin-bottom: 0;">
                      <el-date-picker v-model="scope.row.endDate" type="date" placeholder="选择结束日期" style="width: 100%;" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="层数" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.level" placeholder="请输入层数" />
                  </template>
                </el-table-column>
                <el-table-column label="(含当前层)以下折扣为" width="220">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;gap:8px;">
                      <span>{{ scope.row.level || '—' }}层(含当前层)以下折扣为</span>
                      <el-input v-model="scope.row.belowPercent" placeholder="请输入百分比" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="以上折扣为" width="200">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;gap:8px;">
                      <span>{{ scope.row.level || '—' }}层以上折扣为</span>
                      <el-input v-model="scope.row.abovePercent" placeholder="请输入百分比" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="removeRebateRow(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- type=3 固定单台费用 -->
        <el-row :gutter="20" v-if="form.rebatePlan === '3'">
          <el-col :span="8">
            <el-form-item label="开始日期" prop="fixedUnitPriceStart">
              <el-date-picker v-model="form.fixedUnitPriceStart" type="date" placeholder="选择开始日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束日期" prop="fixedUnitPriceEnd">
              <el-date-picker v-model="form.fixedUnitPriceEnd" type="date" placeholder="选择结束日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单台费用" prop="fixedUnitPrice">
              <el-input v-model="form.fixedUnitPrice" placeholder="请输入单台费用" clearable>
                <template slot="append">元/台</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.fixedUnitPriceRemark" placeholder="请输入备注" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- type=4 按层数不同百分比及固定单台 -->
        <el-row :gutter="20" v-if="form.rebatePlan === '4'">
          <el-col :span="24">
            <el-form-item label="返点设置">
              <div style="margin-bottom: 10px;">
                <el-button type="primary" size="mini" @click="addMixedRebateRow">新增</el-button>
              </div>
              <el-table :data="form.mixedRebateTiers" border size="small" style="width: 100%;">
                <el-table-column label="开始日期" width="180">
                  <template slot="header">
                    <span style="color: #F56C6C;">*</span> 开始日期
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'mixedRebateTiers.' + scope.$index + '.startDate'" :rules="[{ required: true, message: '请选择开始日期', trigger: 'change' }]" style="margin-bottom: 0;">
                      <el-date-picker v-model="scope.row.startDate" type="date" placeholder="选择开始日期" style="width: 100%;" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="结束日期" width="180">
                  <template slot="header">
                    <span style="color: #F56C6C;">*</span> 结束日期
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'mixedRebateTiers.' + scope.$index + '.endDate'" :rules="[{ required: true, message: '请选择结束日期', trigger: 'change' }]" style="margin-bottom: 0;">
                      <el-date-picker v-model="scope.row.endDate" type="date" placeholder="选择结束日期" style="width: 100%;" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="层数" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.level" placeholder="层数" />
                  </template>
                </el-table-column>
                <el-table-column label="以下返点%" width="180">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;gap:4px;">
                      <span>{{ scope.row.level || '—' }}层以下</span>
                      <el-input v-model="scope.row.belowPercent" placeholder="百分比" style="width: 80px;" />
                      <span>%</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="以上返点(元/台)" width="200">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;gap:4px;">
                      <span>{{ scope.row.level || '—' }}层以上</span>
                      <el-input v-model="scope.row.aboveUnitPrice" placeholder="金额" style="width: 80px;" />
                      <span>元/台</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" width="150">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remark" placeholder="备注" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="removeMixedRebateRow(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">保 存</el-button>
    </div>

    <!-- 客户参照选择弹窗 -->
    <el-dialog title="选择客户" :visible.sync="customerReferenceVisible" width="900px" append-to-body :close-on-click-modal="false">
      <!-- 搜索条件 -->
      <el-form :model="customerRefQuery" ref="customerRefForm" :inline="true" size="small">
        <el-form-item label="客户名称">
          <el-input v-model="customerRefQuery.customerName" placeholder="请输入客户名称" clearable style="width: 180px" />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="customerRefQuery.contactPerson" placeholder="请输入联系人" clearable style="width: 180px" />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="customerRefQuery.contactTel" placeholder="请输入联系电话" clearable style="width: 180px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" @click="searchCustomerReference">搜索</el-button>
          <el-button icon="el-icon-refresh" size="small" @click="resetCustomerReference">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 客户列表 -->
      <el-table v-loading="customerRefLoading" :data="customerRefList" border size="small" height="400" highlight-current-row @row-click="handleCustomerRefRowClick">
        <el-table-column width="30" align="center">
          <template slot-scope="scope">
            <el-radio v-model="selectedCustomerRefId" :label="scope.row.id" @change="handleCustomerRefRadioChange(scope.row)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column label="客户名称" align="center" prop="customerName" min-width="160" show-overflow-tooltip />
        <el-table-column label="联系人" align="center" prop="contactPerson" min-width="100" show-overflow-tooltip />
        <el-table-column label="联系电话" align="center" prop="contactPhone" min-width="120" show-overflow-tooltip />
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleCustomerRefSizeChange" @current-change="handleCustomerRefCurrentChange" :current-page="customerRefQuery.currPage" :page-sizes="[10, 20, 50]"
                     :page-size="customerRefQuery.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="customerRefTotal" style="margin-top: 15px; text-align: right;">
      </el-pagination>

      <div slot="footer" class="dialog-footer">
        <el-button @click="customerReferenceVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmCustomerReference" size="small" :disabled="!selectedCustomerRef">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { saveCustBase, updateCustBase, queryCustBaseDetail, queryEmployee, queryCustBaseList } from '@/api/contract/contract';

export default {
  name: 'AddEdit',

  data () {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    // 返点百分比校验：仅允许正数
    const validateRatioValue = (rule, value, callback) => {
      if (this.form && this.form.rebatePlan === '1') {
        if (value === '' || value == null) {
          return callback(new Error('请输入返点百分比'));
        }
        const num = Number(value);
        if (isNaN(num)) {
          return callback(new Error('请输入有效的数字'));
        }
        if (num <= 0) {
          return callback(new Error('返点百分比必须大于0'));
        }
        if (num > 100) {
          return callback(new Error('返点百分比不能超过100'));
        }
      }
      return callback();
    };

    return {
      visible: false,
      loading: false,
      isEdit: false,
      employeeList: [],
      employeeLoading: false,

      // 客户参照选择相关
      customerReferenceVisible: false,
      customerRefLoading: false,
      customerRefList: [],
      customerRefTotal: 0,
      selectedCustomerRef: null,
      selectedCustomerRefId: null,
      customerRefQuery: {
        currPage: 1,
        pageSize: 10,
        customerName: '',
        contactPerson: '',
        contactTel: ''
      },

      // 表单数据
      form: {
        id: undefined, // 本地占位
        customerCode: '',
        customerName: '',
        contactPerson: '',
        contactPhone: '',
        mailingInfo: '', // 常用邮寄信息
        followUpPerson: [],
        projectSource: '',
        invoiceEntity: '',
        status: 'ongoing', // 默认进行中
        rebatePlan: undefined,
        ratioValue: '',
        rebateTiers: [],
        fixedRebateStart: '',
        fixedRebateEnd: '',
        fixedRebateRemark: '',
        // type=3 固定单台费用
        fixedUnitPrice: '',
        fixedUnitPriceStart: '',
        fixedUnitPriceEnd: '',
        fixedUnitPriceRemark: '',
        // type=4 按层数不同百分比及固定单台
        mixedRebateTiers: []
      },

      // 表单验证规则
      rules: {
        customerName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { min: 2, max: 100, message: '客户名称长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        // followUpPerson: [
        //   { required: true, message: '请选择跟单员', trigger: 'change', type: 'array' }
        // ],
        projectSource: [
          { required: true, message: '请选择项目来源', trigger: 'change' }
        ],
        // invoiceEntity: [
        //   { required: true, message: '请选择开票主体', trigger: 'change' }
        // ],
        status: [
          { required: true, message: '请选择客户状态', trigger: 'change' }
        ],
        rebatePlan: [
          { required: true, message: '请选择返点方案', trigger: 'change' }
        ],
        ratioValue: [
          { validator: validateRatioValue, trigger: 'blur' }
        ],
        fixedRebateStart: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        fixedRebateEnd: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ],
        fixedUnitPriceStart: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        fixedUnitPriceEnd: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ]
      }
    };
  },

  computed: {
    dialogTitle () {
      return this.isEdit ? '修改客户' : '新增客户';
    }
  },

  methods: {
    /**
     * 打开对话框
     * @param {String} type - 'Add' 新增 或 'Edit' 修改
     * @param {Object} row - 修改时传入的行数据
     */
    openDialog (type, row = null) {
      this.visible = true;
      this.isEdit = type === 'Edit';
      this.resetForm();

      if (this.isEdit && row) {
        const compCode = row.compCode || row.customerCode;
        this.loading = true;
        queryCustBaseDetail(compCode).then(res => {
          this.loading = false;
          if (res && res.retCode === 'ok') {
            const d = res.additionalData || res.data || res;

            const rebatePlan = d.rebateType != null && d.rebateType !== '' ? String(d.rebateType) : '';
            let ratioValue = '';
            let rebateTiers = [];
            let fixedUnitPrice = '';
            let fixedUnitPriceStart = '';
            let fixedUnitPriceEnd = '';
            let fixedUnitPriceRemark = '';
            let mixedRebateTiers = [];

            if (rebatePlan === '1') {
              if (Array.isArray(d.rebateList) && d.rebateList.length) {
                ratioValue = d.rebateList[0].ratioValue != null ? String(d.rebateList[0].ratioValue) : '';
                this.form.fixedRebateStart = this.normalizeToDate(d.rebateList[0].beginDate) || '';
                this.form.fixedRebateEnd = this.normalizeToDate(d.rebateList[0].endDate) || '';
                this.form.fixedRebateRemark = d.rebateList[0].remark || '';
              } else if (d.ratioValue != null) {
                ratioValue = String(d.ratioValue);
              }
            } else if (rebatePlan === '2') {
              const rlist = Array.isArray(d.rebateList) ? d.rebateList : [];
              const rmap = {};
              rlist.forEach(it => {
                const fn = parseInt(it.floorNum, 10);
                if (isNaN(fn)) return;
                const begin = this.normalizeToDate(it.beginDate) || '';
                const end = this.normalizeToDate(it.endDate) || '';
                if (fn < 0) {
                  const lvl = Math.abs(fn);
                  const key = `${begin}|${end}|${lvl}`;
                  rmap[key] = rmap[key] || { startDate: begin, endDate: end, level: String(lvl), belowPercent: '', abovePercent: '', remark: '' };
                  rmap[key].belowPercent = it.ratioValue != null ? String(it.ratioValue) : '';
                  rmap[key].remark = rmap[key].remark || it.remark || '';
                } else {
                  const lvl = fn - 1;
                  if (lvl >= 0) {
                    const key = `${begin}|${end}|${lvl}`;
                    rmap[key] = rmap[key] || { startDate: begin, endDate: end, level: String(lvl), belowPercent: '', abovePercent: '', remark: '' };
                    rmap[key].abovePercent = it.ratioValue != null ? String(it.ratioValue) : '';
                    rmap[key].remark = rmap[key].remark || it.remark || '';
                  }
                }
              });
              rebateTiers = Object.keys(rmap).sort().map(k => rmap[k]);
            } else if (rebatePlan === '3') {
              // type=3 固定单台费用
              if (Array.isArray(d.rebateList) && d.rebateList.length) {
                fixedUnitPrice = d.rebateList[0].unitPrice != null ? String(d.rebateList[0].unitPrice) : '';
                fixedUnitPriceStart = this.normalizeToDate(d.rebateList[0].beginDate) || '';
                fixedUnitPriceEnd = this.normalizeToDate(d.rebateList[0].endDate) || '';
                fixedUnitPriceRemark = d.rebateList[0].remark || '';
              }
            } else if (rebatePlan === '4') {
              // type=4 按层数不同百分比及固定单台：合并两条记录为一行
              const rlist = Array.isArray(d.rebateList) ? d.rebateList : [];
              const rmap = {};
              rlist.forEach(it => {
                const fn = parseInt(it.floorNum, 10);
                if (isNaN(fn)) return;
                const begin = this.normalizeToDate(it.beginDate) || '';
                const end = this.normalizeToDate(it.endDate) || '';
                if (fn < 0) {
                  // 层数以下用百分比
                  const lvl = Math.abs(fn);
                  const key = `${begin}|${end}|${lvl}`;
                  rmap[key] = rmap[key] || { startDate: begin, endDate: end, level: String(lvl), belowPercent: '', aboveUnitPrice: '', remark: '' };
                  rmap[key].belowPercent = it.ratioValue != null ? String(it.ratioValue) : '';
                  rmap[key].remark = rmap[key].remark || it.remark || '';
                } else {
                  // 层数以上用固定单台费用
                  const lvl = fn - 1;
                  if (lvl >= 0) {
                    const key = `${begin}|${end}|${lvl}`;
                    rmap[key] = rmap[key] || { startDate: begin, endDate: end, level: String(lvl), belowPercent: '', aboveUnitPrice: '', remark: '' };
                    rmap[key].aboveUnitPrice = it.unitPrice != null ? String(it.unitPrice) : '';
                    rmap[key].remark = rmap[key].remark || it.remark || '';
                  }
                }
              });
              mixedRebateTiers = Object.keys(rmap).sort().map(k => rmap[k]);
            }

            this.$nextTick(() => {
              console.log(d.id);

              this.form = {
                id: d.id,
                compCode: d.compCode,
                customerCode: d.compCode || '',
                customerName: d.compName || '',
                contactPerson: d.contactPerson || '',
                contactPhone: d.contactTel || '',
                mailingInfo: d.mailingInfo || '', // 常用邮寄信息
                followUpPerson: d.followPerson ? String(d.followPerson).split(',').map(n => n.trim()).filter(Boolean) : [],
                projectSource: d.projectSource || '',
                invoiceEntity: d.compEntityName || '',
                status: d.enabledState === 0 ? 'completed' : 'ongoing',
                rebatePlan: rebatePlan,
                ratioValue,
                rebateTiers,
                fixedRebateStart: this.form.fixedRebateStart || '',
                fixedRebateEnd: this.form.fixedRebateEnd || '',
                fixedRebateRemark: this.form.fixedRebateRemark || '',
                // type=3 固定单台费用
                fixedUnitPrice,
                fixedUnitPriceStart,
                fixedUnitPriceEnd,
                fixedUnitPriceRemark,
                // type=4 按层数不同百分比及固定单台
                mixedRebateTiers
              };
            });
          } else {
            this.$message.error((res && res.retMsg) || '获取客户详情失败');
          }
        }).catch(err => {
          this.loading = false;
          console.error('获取客户详情失败:', err);
          this.$message.error('获取客户详情失败');
        });
      }
    },

    /**
     * 重置表单
     */
    resetForm () {
      this.form = {
        id: undefined,
        customerCode: '',
        customerName: '',
        contactPerson: '',
        contactPhone: '',
        mailingInfo: '', // 常用邮寄信息
        followUpPerson: ['周云'],
        projectSource: '',
        invoiceEntity: '',
        status: 'ongoing',
        rebatePlan: '',
        ratioValue: '',
        rebateTiers: [],
        fixedRebateStart: '',
        fixedRebateEnd: '',
        fixedRebateRemark: '',
        // type=3 固定单台费用
        fixedUnitPrice: '',
        fixedUnitPriceStart: '',
        fixedUnitPriceEnd: '',
        fixedUnitPriceRemark: '',
        // type=4 按层数不同百分比及固定单台
        mixedRebateTiers: []
      };

      this.$nextTick(() => {
        if (this.$refs.customerForm) {
          this.$refs.customerForm.clearValidate();
        }
      });
    },

    /**
     * 关闭对话框
     */
    handleClose () {
      this.visible = false;
      this.resetForm();
    },

    /**
     * 提交表单
     */
    handleSubmit () {
      // 验证表单
      this.$refs.customerForm.validate((valid) => {
        if (!valid) {
          this.$message.warning('请检查表单填写是否正确');
          return false;
        }

        this.loading = true;

        // 准备提交的数据（仅提交与后端字段明确对应的字段）
        const submitData = {
          // compCode 由后端生成（新增不传）
          compCode: this.form.compCode,
          id: this.form.id,
          compName: this.form.customerName,
          contactPerson: this.form.contactPerson,
          contactTel: this.form.contactPhone,
          mailingInfo: this.form.mailingInfo || '', // 常用邮寄信息
          followPerson: Array.isArray(this.form.followUpPerson) ? this.form.followUpPerson.join(',') : this.form.followUpPerson,
          projectSource: this.form.projectSource,
          compEntityName: this.form.invoiceEntity,
          enabledState: this.form.status === 'completed' ? 0 : 1,
          rebateType: this.form.rebatePlan
        };

        if (this.form.rebatePlan === '1') {
          // 固定返点：使用月份，remark 可选
          submitData.rebateList = [
            {
              beginDate: this.formatDate(this.form.fixedRebateStart),
              endDate: this.formatDate(this.form.fixedRebateEnd),
              ratioValue: this.form.ratioValue !== '' && this.form.ratioValue != null ? String(this.form.ratioValue) : '',
              remark: this.form.fixedRebateRemark || ''
            }
          ];
        } else if (this.form.rebatePlan === '2') {
          // 按层数返点：每行拆成两条，携带月份与备注
          const rlist = [];
          (this.form.rebateTiers || []).forEach(row => {
            const lvl = parseInt(row.level, 10);
            const begin = this.formatDate(row.startDate);
            const end = this.formatDate(row.endDate);
            if (!isNaN(lvl)) {
              if (row.belowPercent !== undefined && row.belowPercent !== '') {
                rlist.push({ beginDate: begin, endDate: end, floorNum: `-${lvl}`, ratioValue: String(row.belowPercent), remark: row.remark || '' });
              }
              if (row.abovePercent !== undefined && row.abovePercent !== '') {
                rlist.push({ beginDate: begin, endDate: end, floorNum: String(lvl + 1), ratioValue: String(row.abovePercent), remark: row.remark || '' });
              }
            }
          });
          submitData.rebateList = rlist;
        } else if (this.form.rebatePlan === '3') {
          // type=3 固定单台费用
          submitData.rebateList = [
            {
              beginDate: this.formatDate(this.form.fixedUnitPriceStart),
              endDate: this.formatDate(this.form.fixedUnitPriceEnd),
              unitPrice: this.form.fixedUnitPrice !== '' && this.form.fixedUnitPrice != null ? String(this.form.fixedUnitPrice) : '',
              remark: this.form.fixedUnitPriceRemark || ''
            }
          ];
        } else if (this.form.rebatePlan === '4') {
          // type=4 按层数不同百分比及固定单台：每行拆成两条记录
          const rlist = [];
          (this.form.mixedRebateTiers || []).forEach(row => {
            const lvl = parseInt(row.level, 10);
            const begin = this.formatDate(row.startDate);
            const end = this.formatDate(row.endDate);
            if (!isNaN(lvl)) {
              // 层数以下用百分比
              if (row.belowPercent !== undefined && row.belowPercent !== '') {
                rlist.push({ beginDate: begin, endDate: end, floorNum: `-${lvl}`, ratioValue: String(row.belowPercent), remark: row.remark || '' });
              }
              // 层数以上用固定单台费用
              if (row.aboveUnitPrice !== undefined && row.aboveUnitPrice !== '') {
                rlist.push({ beginDate: begin, endDate: end, floorNum: String(lvl + 1), unitPrice: String(row.aboveUnitPrice), remark: row.remark || '' });
              }
            }
          });
          submitData.rebateList = rlist;
        }
        console.log(submitData);

        const apiCall = this.isEdit ? updateCustBase(submitData) : saveCustBase(submitData);
        apiCall.then(res => {
          this.loading = false;
          if (res && res.retCode === 'ok') {
            this.$message.success(this.isEdit ? '修改成功' : '新增成功');
            this.handleClose();
            this.$emit('refresh');
          } else {
            this.$message.error((res && res.retMsg) || (this.isEdit ? '修改失败' : '新增失败'));
          }
        }).catch(error => {
          this.loading = false;
          console.error(this.isEdit ? '修改失败:' : '新增失败:', error);
          this.$message.error(error && error.message ? error.message : (this.isEdit ? '修改失败' : '新增失败'));
        });
      });
    }
    ,
    formatDate (val) {
      if (!val) return '';
      if (typeof val === 'string') return val;
      if (val instanceof Date) {
        const y = val.getFullYear();
        const m = String(val.getMonth() + 1).padStart(2, '0');
        const d = String(val.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      }
      return '';
    }
    ,
    formatMonth (val) {
      if (!val) return '';
      if (typeof val === 'string') {
        // if already yyyy-mm or yyyy-mm-dd, trim to yyyy-mm
        const m = val.slice(0, 7);
        return m;
      }
      if (val instanceof Date) {
        // const y = val.getFullYear();
        const m = String(val.getMonth() + 1).padStart(2, '0');
        return `${y}-${m}`;
      }
      return '';
    }
    ,
    normalizeToDate (val) {
      if (!val) return '';
      if (val instanceof Date) return this.formatDate(val);
      if (typeof val === 'string') {
        if (val.length === 7) return `${val}-01`;
        if (val.length === 10) return val;
      }
      return '';
    }
    ,
    addRebateRow () {
      this.form.rebateTiers.push({ startDate: '', endDate: '', level: '', belowPercent: '', abovePercent: '', remark: '' });
    }
    ,
    removeRebateRow (index) {
      this.form.rebateTiers.splice(index, 1);
    }
    ,
    addMixedRebateRow () {
      this.form.mixedRebateTiers.push({ startDate: '', endDate: '', level: '', belowPercent: '', aboveUnitPrice: '', remark: '' });
    }
    ,
    removeMixedRebateRow (index) {
      this.form.mixedRebateTiers.splice(index, 1);
    }
    ,
    onRebatePlanChange (val) {
      // 清空 type=1 固定百分比相关字段
      if (val !== '1') {
        this.form.ratioValue = ''
        this.form.fixedRebateStart = ''
        this.form.fixedRebateEnd = ''
        this.form.fixedRebateRemark = ''
      }
      // 清空 type=2 按检测日期以及层数不同百分比相关字段
      if (val !== '2') {
        this.form.rebateTiers = []
      }
      // 清空 type=3 固定单台费用相关字段
      if (val !== '3') {
        this.form.fixedUnitPrice = ''
        this.form.fixedUnitPriceStart = ''
        this.form.fixedUnitPriceEnd = ''
        this.form.fixedUnitPriceRemark = ''
      }
      // 清空 type=4 按层数不同百分比及固定单台相关字段
      if (val !== '4') {
        this.form.mixedRebateTiers = []
      }
    },
    loadEmployeeList () {
      if (this.employeeList.length > 0 || this.employeeLoading) {
        return
      }

      this.employeeLoading = true
      const params = {
        pageSize: 200,
        curPage: 1
      }

      queryEmployee(params)
        .then(res => {
          if (res.dataList) {
            this.employeeList = res.dataList || []
          } else {
            this.$message.error(res.retMsg || '获取职员列表失败')
            this.employeeList = []
          }
          this.employeeLoading = false
        })
        .catch(err => {
          this.$message.error('获取职员列表失败：' + (err.message || '网络错误'))
          this.employeeList = []
          this.employeeLoading = false
        })
    },

    /**
     * 打开客户参照选择弹窗
     */
    openCustomerReference () {
      this.customerReferenceVisible = true;
      this.selectedCustomerRef = null;
      this.selectedCustomerRefId = null;
      this.resetCustomerReference();
    },

    /**
     * 获取客户参照列表
     */
    getCustomerReferenceList () {
      this.customerRefLoading = true;

      // 区域名称映射
      const regionCodeToName = {
        fuzhou: '福州市',
        xiamen: '厦门市',
        quanzhou: '泉州市',
        zhangzhou: '漳州市',
        putian: '莆田市',
        longyan: '龙岩市',
        sanming: '三明市',
        nanping: '南平市',
        ningde: '宁德市'
      };

      const payload = {
        currPage: this.customerRefQuery.currPage,
        pageSize: this.customerRefQuery.pageSize,
        compName: this.customerRefQuery.customerName,
        contactPerson: this.customerRefQuery.contactPerson,
        contactTel: this.customerRefQuery.contactTel,
        enabledState: -1 // 查询所有状态
      };

      queryCustBaseList(payload).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const { records = [], current = this.customerRefQuery.currPage, size = this.customerRefQuery.pageSize, total = 0 } = res.additionalData || {};

          // 映射数据
          this.customerRefList = records.map((item, index) => {
            return {
              ...item,
              id: item.id || item.custPid || index,
              customerCode: item.compCode || '',
              customerName: item.compName || '',
              projectName: item.projectName || '',
              region: item.contRegion || '',
              contactPerson: item.contactPerson || '',
              contactPhone: item.contactTel || '',
              followUpPerson: item.followPerson || '',
              projectSource: item.projectSource || '',
              invoiceEntity: item.compEntityName || '',
              status: item.enabledState === 1 ? 1 : 0,
              contRegion: item.contRegion || '',
              contRegionCode: item.contRegionCode || ''
            };
          });

          this.customerRefQuery.currPage = current;
          this.customerRefQuery.pageSize = size;
          this.customerRefTotal = total;
        } else {
          this.$message.error((res && res.retMsg) || '获取客户列表失败');
        }
        this.customerRefLoading = false;
      }).catch(error => {
        console.error('获取客户列表失败:', error);
        this.customerRefLoading = false;
        this.$message.error('获取客户列表失败');
      });
    },

    /**
     * 搜索客户参照
     */
    searchCustomerReference () {
      this.customerRefQuery.currPage = 1;
      this.getCustomerReferenceList();
    },

    /**
     * 重置客户参照搜索
     */
    resetCustomerReference () {
      this.customerRefQuery = {
        currPage: 1,
        pageSize: 10,
        customerName: '',
        contactPerson: '',
        contactTel: ''
      };
      this.getCustomerReferenceList();
    },

    /**
     * 客户参照行点击
     */
    handleCustomerRefRowClick (row) {
      this.selectedCustomerRefId = row.id;
      this.selectedCustomerRef = row;
    },

    /**
     * 客户参照单选框变化
     */
    handleCustomerRefRadioChange (row) {
      this.selectedCustomerRef = row;
    },

    /**
     * 客户参照分页大小改变
     */
    handleCustomerRefSizeChange (val) {
      this.customerRefQuery.pageSize = val;
      this.getCustomerReferenceList();
    },

    /**
     * 客户参照当前页改变
     */
    handleCustomerRefCurrentChange (val) {
      this.customerRefQuery.currPage = val;
      this.getCustomerReferenceList();
    },

    /**
     * 确认选择客户参照 - 完整回填所有数据
     */
    confirmCustomerReference () {
      if (!this.selectedCustomerRef) {
        this.$message.warning('请选择一条客户记录');
        return;
      }

      const row = this.selectedCustomerRef;
      const compCode = row.compCode || row.customerCode;

      this.loading = true;
      // 调用详情接口获取完整数据
      queryCustBaseDetail(compCode).then(res => {
        this.loading = false;
        if (res && res.retCode === 'ok') {
          const d = res.additionalData || res.data || res;

          // 返点方案处理
          const rebatePlan = d.rebateType != null && d.rebateType !== '' ? String(d.rebateType) : '';
          let ratioValue = '';
          let rebateTiers = [];
          let fixedRebateStart = '';
          let fixedRebateEnd = '';
          let fixedRebateRemark = '';
          let fixedUnitPrice = '';
          let fixedUnitPriceStart = '';
          let fixedUnitPriceEnd = '';
          let fixedUnitPriceRemark = '';
          let mixedRebateTiers = [];

          if (rebatePlan === '1') {
            if (Array.isArray(d.rebateList) && d.rebateList.length) {
              ratioValue = d.rebateList[0].ratioValue != null ? String(d.rebateList[0].ratioValue) : '';
              fixedRebateStart = this.normalizeToDate(d.rebateList[0].beginDate) || '';
              fixedRebateEnd = this.normalizeToDate(d.rebateList[0].endDate) || '';
              fixedRebateRemark = d.rebateList[0].remark || '';
            } else if (d.ratioValue != null) {
              ratioValue = String(d.ratioValue);
            }
          } else if (rebatePlan === '2') {
            const rlist = Array.isArray(d.rebateList) ? d.rebateList : [];
            const rmap = {};
            rlist.forEach(it => {
              const fn = parseInt(it.floorNum, 10);
              if (isNaN(fn)) return;
              const begin = this.normalizeToDate(it.beginDate) || '';
              const end = this.normalizeToDate(it.endDate) || '';
              if (fn < 0) {
                const lvl = Math.abs(fn);
                const key = `${begin}|${end}|${lvl}`;
                rmap[key] = rmap[key] || { startDate: begin, endDate: end, level: String(lvl), belowPercent: '', abovePercent: '', remark: '' };
                rmap[key].belowPercent = it.ratioValue != null ? String(it.ratioValue) : '';
                rmap[key].remark = rmap[key].remark || it.remark || '';
              } else {
                const lvl = fn - 1;
                if (lvl >= 0) {
                  const key = `${begin}|${end}|${lvl}`;
                  rmap[key] = rmap[key] || { startDate: begin, endDate: end, level: String(lvl), belowPercent: '', abovePercent: '', remark: '' };
                  rmap[key].abovePercent = it.ratioValue != null ? String(it.ratioValue) : '';
                  rmap[key].remark = rmap[key].remark || it.remark || '';
                }
              }
            });
            rebateTiers = Object.keys(rmap).sort().map(k => rmap[k]);
          } else if (rebatePlan === '3') {
            // type=3 固定单台费用
            if (Array.isArray(d.rebateList) && d.rebateList.length) {
              fixedUnitPrice = d.rebateList[0].unitPrice != null ? String(d.rebateList[0].unitPrice) : '';
              fixedUnitPriceStart = this.normalizeToDate(d.rebateList[0].beginDate) || '';
              fixedUnitPriceEnd = this.normalizeToDate(d.rebateList[0].endDate) || '';
              fixedUnitPriceRemark = d.rebateList[0].remark || '';
            }
          } else if (rebatePlan === '4') {
            // type=4 按层数不同百分比及固定单台
            const rlist = Array.isArray(d.rebateList) ? d.rebateList : [];
            const rmap = {};
            rlist.forEach(it => {
              const fn = parseInt(it.floorNum, 10);
              if (isNaN(fn)) return;
              const begin = this.normalizeToDate(it.beginDate) || '';
              const end = this.normalizeToDate(it.endDate) || '';
              if (fn < 0) {
                const lvl = Math.abs(fn);
                const key = `${begin}|${end}|${lvl}`;
                rmap[key] = rmap[key] || { startDate: begin, endDate: end, level: String(lvl), belowPercent: '', aboveUnitPrice: '', remark: '' };
                rmap[key].belowPercent = it.ratioValue != null ? String(it.ratioValue) : '';
                rmap[key].remark = rmap[key].remark || it.remark || '';
              } else {
                const lvl = fn - 1;
                if (lvl >= 0) {
                  const key = `${begin}|${end}|${lvl}`;
                  rmap[key] = rmap[key] || { startDate: begin, endDate: end, level: String(lvl), belowPercent: '', aboveUnitPrice: '', remark: '' };
                  rmap[key].aboveUnitPrice = it.unitPrice != null ? String(it.unitPrice) : '';
                  rmap[key].remark = rmap[key].remark || it.remark || '';
                }
              }
            });
            mixedRebateTiers = Object.keys(rmap).sort().map(k => rmap[k]);
          }

          // 完整回填所有数据
          this.$nextTick(() => {
            this.form.customerName = d.compName || '';
            this.form.contactPerson = d.contactPerson || '';
            this.form.contactPhone = d.contactTel || '';
            this.form.mailingInfo = d.mailingInfo || ''; // 常用邮寄信息
            this.form.followUpPerson = d.followPerson ? String(d.followPerson).split(',').map(n => n.trim()).filter(Boolean) : [];
            this.form.projectSource = d.projectSource || '';
            this.form.invoiceEntity = d.compEntityName || '';
            this.form.status = d.enabledState === 0 ? 'completed' : 'ongoing';

            // 返点方案
            this.form.rebatePlan = rebatePlan;
            this.form.ratioValue = ratioValue;
            this.form.rebateTiers = rebateTiers;
            this.form.fixedRebateStart = fixedRebateStart;
            this.form.fixedRebateEnd = fixedRebateEnd;
            this.form.fixedRebateRemark = fixedRebateRemark;
            // type=3 固定单台费用
            this.form.fixedUnitPrice = fixedUnitPrice;
            this.form.fixedUnitPriceStart = fixedUnitPriceStart;
            this.form.fixedUnitPriceEnd = fixedUnitPriceEnd;
            this.form.fixedUnitPriceRemark = fixedUnitPriceRemark;
            // type=4 按层数不同百分比及固定单台
            this.form.mixedRebateTiers = mixedRebateTiers;

            // 关闭弹窗
            this.customerReferenceVisible = false;
            this.$message.success('客户信息已完整回填');
          });
        } else {
          this.$message.error((res && res.retMsg) || '获取客户详情失败');
        }
      }).catch(err => {
        this.loading = false;
        console.error('获取客户详情失败:', err);
        this.$message.error('获取客户详情失败');
      });
    }
  }
};
</script>

<style scoped>
.dialog-content {
  max-height: 65vh;
  overflow-y: auto;
  padding: 0 15px;
}

.form-section {
  margin-bottom: 20px;
  padding: 15px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 3px solid #409eff;
}

.rebate-detail-box {
  margin-top: 15px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.table-toolbar {
  margin-bottom: 10px;
}

.el-form-item {
  margin-bottom: 18px;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.delete-btn {
  color: #f56c6c;
}

.delete-btn:hover {
  color: #f78989;
}

/* 禁用状态的输入框样式 */
.el-input.is-disabled >>> .el-input__inner {
  background-color: #f5f7fa;
  color: #606266;
  cursor: not-allowed;
}

/* 表格内输入框样式优化 */
::v-deep .el-table .el-input-group__prepend {
  padding: 0 5px;
  font-size: 12px;
}

::v-deep .el-table .el-input-group__append {
  padding: 0 8px;
}
</style>

